import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'patient-jitsi-meeting',
  imports: [],
  templateUrl: './jitsi-meeting.component.html',
  styleUrl: './jitsi-meeting.component.css',
})
export class JitsiMeetingComponent {
  @Input() config: any;

  @ViewChild('jitsiContainer', { static: true })
  jitsiContainer!: ElementRef;

  jitsiApi: any;

  ngOnInit(): void {
    console.log(this.config, ' this is in jisti');

    this.createJitsiMeeting();
  }

  private createJitsiMeeting(): void {
    if (!this.jitsiContainer || !this.config) {
      return;
    }

    try {
      const domain = this.config.domain;

      const options: any = {
        roomName: this.config.roomName,
        width: '100%',
        height: '100%',
        parentNode: this.jitsiContainer.nativeElement,

        configOverwrite: {
          startWithAudioMuted: true,
          startWithVideoMuted: true,
          prejoinPageEnabled: false,
          disableDeepLinking: true,
          disableTileView: true,
          disableFilmstrip: true,
        },

        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_BRAND_WATERMARK: false,
          TILE_VIEW_MAX_COLUMNS: 1,
          TOOLBAR_BUTTONS: [
            'microphone',
            'camera',
            'closedcaptions',
            'desktop',
            'fullscreen',
            'fodeviceselection',
            'hangup',
            'profile',
            'chat',
            'recording',
            'livestreaming',
            'sharedvideo',
            'settings',
            'raisehand',
            'videoquality',
            'feedback',
            'stats',
            'participants-pane',
            'shortcuts',
            'videobackgroundblur',
            'help',
            'mute-everyone',
            'security',
          ],
        },

        jwt: this.config.token,
      };

      this.jitsiApi = new window.JitsiMeetExternalAPI(domain, options);

      this.jitsiApi.addEventListener('conferenceJoined', () => {
        setTimeout(() => {
          this.jitsiApi.executeCommand('subject', 'Test Title');
        }, 500);
      });
    } catch (error) {
      console.error('Failed to initialize meeting', error);
    }
  }
}
